import { v3Url } from '@/utils/fetcher';
import { useAxios } from '../base/useAxios';

export default function useCalendarEventsPlanningPermissionsActions() {
  const api = useAxios();

  return {
    enableCalendarEventsPlanning({ calendar, includeSingleAttendeeEvents }) {
      const payload = { calendar };
      if (includeSingleAttendeeEvents !== undefined) {
        payload.includeSingleAttendeeEvents = includeSingleAttendeeEvents;
      }
      return api.post(v3Url(`calendars/permission`), payload);
    },
    disableCalendarEventsPlanning({ type }) {
      return api.delete(v3Url(`calendars/permission/${type}`));
    },
  };
}
